import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
// import Header from "../components/Login_Header";
import { ApiError } from "../lib/api";
import { completeSocialLogin } from "../lib/auth-api";
import { consumePendingOauthState } from "../lib/social-auth";
// import Login_Header from "../components/Login_Header";

export default function OAuthCallback() {
  const { provider } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get("code");
    const returnedState = searchParams.get("state");
    const providerError = searchParams.get("error");
    const pending = consumePendingOauthState();

    if (providerError) {
      setError("Login was cancelled or denied.");
      return;
    }
    if (
      !code ||
      !returnedState ||
      !pending ||
      pending.state !== returnedState ||
      pending.provider !== provider
    ) {
      setError("Invalid or expired login attempt. Please try again.");
      return;
    }

    completeSocialLogin(pending.provider, code, returnedState)
      .then(() => navigate("/delete-account", { replace: true }))
      .catch((err) => {
        setError(
          err instanceof ApiError
            ? err.message
            : "Login failed. Please try again.",
        );
      });
  }, [provider, searchParams, navigate]);

  return (
    <div className="page">
      {/* <Login_Header /> */}
      <main
        style={{
          maxWidth: 472,
          margin: "64px auto",
          padding: "0 24px",
          textAlign: "center",
        }}
      >
        {error ? (
          <>
            <p style={{ color: "var(--red)", marginBottom: 16 }}>{error}</p>
            <button onClick={() => navigate("/", { replace: true })}>
              Back to login
            </button>
          </>
        ) : (
          <p>Signing you in…</p>
        )}
      </main>
    </div>
  );
}
